// pages/Profile.jsx
import React, { useEffect, useState } from "react";
import ProfileCard from "../../components/ProfileCard";
import StatsCards from "../../components/StatsCards";
import Header from "../../components/Header.js";
import { useNavigate, useLocation } from "react-router-dom";
import { getUserDetailsById } from "../../services/authServices.js";
import { getDahboardStats } from "../../services/companyService.js";
import Loading from "../../components/Loading.js";

const Profile = () => {
  const navigate = useNavigate();
  const query = new URLSearchParams(useLocation().search);
  const userId = parseInt(query.get("user")) || 0;
  const [user, setUser] = useState(null);
  const [statistitcs, setStatistitcs] = useState([
    {
      label: "Total Forms",
      value: 0,
      color: "text-indigo-500",
      border: "border-indigo-300",
    },
    {
      label: "Approved Forms",
      value: 0,
      color: "text-green-600",
      border: "border-green-300",
    },
    {
      label: "Pending Forms",
      value: 0,
      color: "text-yellow-500",
      border: "border-yellow-300",
    },
    {
      label: "Rejected Forms",
      value: 0,
      color: "text-red-500",
      border: "border-red-300",
    },
  ]);

  const getUser = async () => {
    let userData = {
      image: "/images/user-profile-icon.png",
      name: "Lorem Ipsum",
      role: "Validator",
      id: "S2210",
      joiningDate: "10/01/2025",
      maxTime: "24 mins",
      minTime: "12 mins",
      avgTime: "18:44",
      totalFilled: 56,
      status: "Active",
    };
    const response = await getUserDetailsById(userId);
    const joiningDate = new Date(response.createdAt).toLocaleDateString(
      "en-GB",
      {
        weekday: "long",
        day: "2-digit",
        month: "short",
        year: "numeric",
      }
    );
    userData = { ...userData, ...response, joiningDate };

    console.log(userData);
    setUser(userData);
  };
  const fetchDashboard = async () => {
    try {
      const response = await getDahboardStats(user);
      setStatistitcs([
        {
          label: "Total Forms",
          value: response.totalForms,
          color: "text-indigo-500",
          border: "border-indigo-300",
        },
        {
          label: "Approved Forms",
          value: response.approvedForms,
          color: "text-green-600",
          border: "border-green-300",
        },
        {
          label: "Pending Forms",
          value: response.pendingForms,
          color: "text-yellow-500",
          border: "border-yellow-300",
        },
        {
          label: "Rejected Forms",
          value: response.rejectedForms,
          color: "text-red-500",
          border: "border-red-300",
        },
      ]);
    } catch (error) {
      console.error("Failed to fetch stats:", error);
    }
  };

  useEffect(() => {
    getUser();
    fetchDashboard();
  }, {});

  return (
    <div className="py-8 px-[5rem] bg-[#fbfbfb] w-screen mx-auto">
      <Header title="Validator's Profile" />
      <div className="my-4">
        {user && <ProfileCard user={user} />}
        {!user && <Loading />}
      </div>
      <div className="mt-6">
        <h2 className="text-xl font-bold mb-2">Forms Statistitcs</h2>
        <p className="text-sm text-gray-600 mb-4">Total Forms: 52 Forms</p>
        <StatsCards stats={statistitcs} />
      </div>
    </div>
  );
};

export default Profile;
